// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** IAAnywhere Branded Styling **/

:root {
    /* Fonts */

    --opensans-font: 'Open Sans', sans-serif;
    --opensans-light: 300;
    --opensans-regular: 400;
    --opensans-semibold: 600;

    --roboto-font: 'Roboto', sans-serif;
    --roboto-light: 300;
    --roboto-regular: 400;
    --roboto-medium: 500;
    --roboto-semibold: 600;

    --font-size: 16px;
    --line-height: 1.5;
    --font-weight: --opensans-light;

    /* Branded Colors */

    --white: #ffffff;
    --white-002: #fbfbfb;
    --white-003: #f7f8fa;

    --body-background: #ebecee;
    --border-grey: #ddd;
    --grey-001: #3f4554;
    --grey-002: #323439;
    --grey-003: #495061;
    --grey-004: #9a9faa;
    --grey-005: #808695;
    --grey-006: #b0b4bd;
    --grey-007: #a9a9a9;

    --aqua-001: #04c3ca;
    --aqua-002: #1cd5db;
    --aqua-003: #dde3ec;
    --aqua-004: #8290a3;
    --aqua-005: #ebfafb;

    --red-001: #d91e18;
    --red-002: #a35151;

    --green-001: #51a351;

    --black-001: #495057;
    --black-002: #212529;
}

/* Viewport Size Breakpoints */

/** --g-3xs: 320px;  double extra small devices (<=320px) **/

/** --g-2xs: 446px;  double extra small devices (<=445px) **/

/** --g-sm: 576px;  small devices (landscape phones, >=576 & <=766) **/

/** --g-md: 767px;  medium devices (tablets, >=767 & <=991) **/

/** --g-lg: 992px;  large devices (desktops, >=992 & <=1199) **/

/** --g-xl: 1200px;  extra large devices (large desktops, >=1200) **/

@custom-media --3xs-viewport (max-width: 320px);

@custom-media --3xs-min-viewport (min-width: 320px);

@custom-media --2xs-viewport (max-width: 446px);

@custom-media --2xs-min-viewport (min-width: 446px);

.breadcrumb-main {
  padding-top: 30px;
  padding-bottom: 7px;
}

.breadcrumb-main h3 {
    color: #808695;
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
    font-size: 22px;
  }

.breadcrumb-main a {
    color: #808695;
    font-family: 'Open Sans', sans-serif;
    font-weight: 300;
    font-size: 13px;
  }

.breadcrumb-main a.disabled {
      cursor: default;
      pointer-events: none;
    }

.breadcrumb {
  padding: 0rem 0rem;
  line-height: 26px;
}

.breadcrumb-item.active {
  color: #808695;
  font-family: 'Open Sans', sans-serif;
  font-weight: 300;
  font-size: 13px;
}

.breadcrumb-item + .breadcrumb-item::before {
  color: #808695;
  content: '-';
}
`, "",{"version":3,"sources":["webpack://./src/branding.css","webpack://./src/resources/elements/title-breadcrumbs.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;IACI,UAAU;;IAEV,wCAAwC;IACxC,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;;IAExB,mCAAmC;IACnC,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;IACpB,sBAAsB;;IAEtB,iBAAiB;IACjB,kBAAkB;IAClB,+BAA+B;;IAE/B,mBAAmB;;IAEnB,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;;IAEpB,0BAA0B;IAC1B,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;;IAEnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;;IAEnB,kBAAkB;IAClB,kBAAkB;;IAElB,oBAAoB;;IAEpB,oBAAoB;IACpB,oBAAoB;AACxB;;AAGA,8BAA8B;;AAE9B,4DAA4D;;AAC5D,4DAA4D;;AAC5D,sEAAsE;;AACtE,8DAA8D;;AAC9D,+DAA+D;;AAC/D,oEAAoE;;AAUpE,+CAA+C;;AAC/C,mDAAmD;;AACnD,+CAA+C;;AAC/C,mDAAmD;;ACvEnD;EACE,iBAAiB;EACjB,mBAAmB;AAiBrB;;AAhBE;IACE,cAAsB;IACtB,iCAA+B;IAC/B,gBAAkC;IAClC,eAAe;EACjB;;AACA;IACE,cAAsB;IACtB,oCAAiC;IACjC,gBAAkC;IAClC,eAAe;EAKjB;;AAJE;MACE,eAAe;MACf,oBAAoB;IACtB;;AAIJ;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAsB;EACtB,oCAAiC;EACjC,gBAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,cAAsB;EACtB,YAAY;AACd","sourcesContent":["/** IAAnywhere Branded Styling **/\r\n\r\n:root {\r\n    /* Fonts */\r\n\r\n    --opensans-font: 'Open Sans', sans-serif;\r\n    --opensans-light: 300;\r\n    --opensans-regular: 400;\r\n    --opensans-semibold: 600;\r\n\r\n    --roboto-font: 'Roboto', sans-serif;\r\n    --roboto-light: 300;\r\n    --roboto-regular: 400;\r\n    --roboto-medium: 500;\r\n    --roboto-semibold: 600;\r\n\r\n    --font-size: 16px;\r\n    --line-height: 1.5;\r\n    --font-weight: --opensans-light;\r\n\r\n    /* Branded Colors */\r\n\r\n    --white: #ffffff;\r\n    --white-002: #fbfbfb;\r\n    --white-003: #f7f8fa;\r\n\r\n    --body-background: #ebecee;\r\n    --border-grey: #ddd;\r\n    --grey-001: #3f4554;\r\n    --grey-002: #323439;\r\n    --grey-003: #495061;\r\n    --grey-004: #9a9faa;\r\n    --grey-005: #808695;\r\n    --grey-006: #b0b4bd;\r\n    --grey-007: #a9a9a9;\r\n\r\n    --aqua-001: #04c3ca;\r\n    --aqua-002: #1cd5db;\r\n    --aqua-003: #dde3ec;\r\n    --aqua-004: #8290a3;\r\n    --aqua-005: #ebfafb;\r\n\r\n    --red-001: #d91e18;\r\n    --red-002: #a35151;\r\n\r\n    --green-001: #51a351;\r\n\r\n    --black-001: #495057;\r\n    --black-002: #212529;\r\n}\r\n\r\n\r\n/* Viewport Size Breakpoints */\r\n\r\n/** --g-3xs: 320px;  double extra small devices (<=320px) **/\r\n/** --g-2xs: 446px;  double extra small devices (<=445px) **/\r\n/** --g-sm: 576px;  small devices (landscape phones, >=576 & <=766) **/\r\n/** --g-md: 767px;  medium devices (tablets, >=767 & <=991) **/\r\n/** --g-lg: 992px;  large devices (desktops, >=992 & <=1199) **/\r\n/** --g-xl: 1200px;  extra large devices (large desktops, >=1200) **/\r\n\r\n@custom-media --xl-viewport (max-width: 1200px);\r\n@custom-media --xl-min-viewport (min-width: 1200px);\r\n@custom-media --lg-viewport (max-width: 992px);\r\n@custom-media --lg-min-viewport (min-width: 992px);\r\n@custom-media --md-viewport (max-width: 767px);\r\n@custom-media --md-min-viewport (min-width: 767px);\r\n@custom-media --sm-viewport (max-width: 576px);\r\n@custom-media --sm-min-viewport (min-width: 576px);\r\n@custom-media --3xs-viewport (max-width: 320px);\r\n@custom-media --3xs-min-viewport (min-width: 320px);\r\n@custom-media --2xs-viewport (max-width: 446px);\r\n@custom-media --2xs-min-viewport (min-width: 446px);","@import '../../branding';\r\n.breadcrumb-main {\r\n  padding-top: 30px;\r\n  padding-bottom: 7px;\r\n  h3 {\r\n    color: var(--grey-005);\r\n    font-family: var(--roboto-font);\r\n    font-weight: var(--roboto-regular);\r\n    font-size: 22px;\r\n  }\r\n  a {\r\n    color: var(--grey-005);\r\n    font-family: var(--opensans-font);\r\n    font-weight: var(--opensans-light);\r\n    font-size: 13px;\r\n    &.disabled {\r\n      cursor: default;\r\n      pointer-events: none;\r\n    }\r\n  }\r\n}\r\n\r\n.breadcrumb {\r\n  padding: 0rem 0rem;\r\n  line-height: 26px;\r\n}\r\n\r\n.breadcrumb-item.active {\r\n  color: var(--grey-005);\r\n  font-family: var(--opensans-font);\r\n  font-weight: var(--opensans-light);\r\n  font-size: 13px;\r\n}\r\n\r\n.breadcrumb-item + .breadcrumb-item::before {\r\n  color: var(--grey-005);\r\n  content: '-';\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
